import(/* webpackMode: "eager" */ "/workspace/src/app/delivery-times/page.tsx");
